/**
 * OrderbooksPausedBadge — amber "books paused" pill shown while hydra has
 * this connection throttled at backpressure level >= 2 (orderbook frames
 * suspended server-side; market + consensus keep flowing, so the regular
 * freshness dot stays green while every book on screen is frozen).
 *
 * Renders nothing at level < 2. Clears automatically: orderbook frames
 * resuming is the recovery signal (hydra sends no "recovered" message),
 * and HydraClient/hydraWorker reset the store level on the first frame.
 * Mount in any view that renders orderbook-derived data (depth, maker
 * pills, top-of-book prices from the orderbooks channel).
 */

import { useMarketStore } from '@/stores/marketStore';

export function OrderbooksPausedBadge() {
  const paused = useMarketStore((s) => s.backpressureLevel >= 2);
  if (!paused) return null;
  return (
    <span
      className="bg-amber-500/15 text-amber-400 inline-flex shrink-0 items-center gap-1.5 rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wider"
      title="Hydra is throttling this connection (backpressure level 2+) — orderbook updates are suspended until the feed drains. Books shown are frozen at their last value; prices update again automatically."
    >
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-amber-400" />
      books paused
    </span>
  );
}
